import { Typography, useTheme } from '@mui/material'
import { useFetchOrgsList } from 'hooks/use-admin'
import { MenuItemWithDarkMode } from 'dark-mode-components'
import Selector from 'components/Selector'
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { COLORS } from 'app-constants'

const OrganizationSelector = ({
  organizationId,
  setOrganizationId,
}: {
  organizationId: string
  setOrganizationId: (orgId: string) => void
}) => {
  const theme = useTheme()
  const { adminOrgs } = useFetchOrgsList()

  return (
    <Selector
      id="organization-selector"
      isDarkBackdrop={true}
      label="Organization"
      option={organizationId || null}
      options={adminOrgs}
      setOption={setOrganizationId}
      width="280px"
      placeholder="Select an organization"
      defaultOption={
        <MenuItemWithDarkMode key={''} value={''} theme={theme} isSelected={organizationId === ''}>
          {organizationId === '' ? (
            <RadioButtonCheckedIcon
              sx={{
                fill: COLORS.JELLED_PRIMARY_BLUE,
              }}
            />
          ) : (
            <RadioButtonUncheckedIcon
              sx={{
                fill: COLORS.GRAY_2,
              }}
            />
          )}
          <Typography
            variant="body1"
            sx={{
              ml: 1,
              color: organizationId === '' ? COLORS.JELLED_PRIMARY_BLUE : COLORS.GRAY_2,
            }}>
            All
          </Typography>
        </MenuItemWithDarkMode>
      }
    />
  )
}

export default OrganizationSelector
